import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const BarChart = ({ text, chartLabels, chartData }: any) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: text,
      },
    },
  };
  // const labels = [startDate + ' - ' + endDate];
  const labels = chartData.map((item: any) => item.InvoiceDate);
  const outletData = chartData.map((item: any) => parseFloat(item.Outlet.replace(',', '')));
  const onlineData = chartData.map((item: any) => parseFloat(item.Online.replace(',', '')));

  const data = {
    labels,
    datasets: [
      {
        label: chartLabels[0],
        data: onlineData,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: chartLabels[1],
        data: outletData,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };
  return <Bar options={options} data={data} />;
};
export const BarChart2 = ({ text, chartLabels, chartData }: any) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: text,
      },
    },
  };

  const labels = Object.keys(chartData);
  const a = labels.map((e) => chartData[e].length);

  const data = {
    labels,
    datasets: [
      {
        label: chartLabels[0],
        data: a,
        borderColor: 'rgba(153, 102, 255, 1)',
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
      },
    ],
  };
  return <Bar options={options} data={data} />;
};
export const BarChart3 = ({ text, chartLabels, chartData }: any) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: text,
      },
    },
  };
  const labels = chartData.map((item: any) => item.email);
  const data_sale = chartData.map((item: any) => item.total_sale);

  const data = {
    labels,
    datasets: [
      {
        label: chartLabels[0],
        data: data_sale,
        borderColor: 'rgba(255, 206, 86, 1)',
        backgroundColor: 'rgba(255, 206, 86, 1)',
      },
    ],
  };
  return <Bar options={options} data={data} />;
};
export const BarChart4 = ({ text, chartLabels, chartData }: any) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: text,
      },
    },
  };
  const labels = chartData.map((item: any) => item.email);
  const data_sale = chartData.map((item: any) => item.total_sale);

  const data = {
    labels,
    datasets: [
      {
        label: chartLabels[0],
        data: data_sale,
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 1)',
      },
    ],
  };
  return <Bar options={options} data={data} />;
};
